import { render } from "./ArchiveRecord.vue?vue&type=template&id=d575f05e"
import script from "./ArchiveRecord.vue?vue&type=script&lang=js"
export * from "./ArchiveRecord.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__